import { SERVICES } from "../../configs/constants";

export default {
  display: true,
  title: "Base PDCs",
  contentType: "menu",
  canReduce: true,
  search: false,
  content: [
    {
      label: "Liste des PDCs",
      icon: "pdc",
      id: "listpdcs",
      component: "",
      path: "/basepdc/listpdcs",
      onClick: "",
      service: SERVICES.PDC
    },
    {
      label: "Requètes",
      icon: "request",
      id: "request",
      component: "",
      path: "/basepdc/requests",
      onClick: "",
      service: SERVICES.PDC,
      minRole: 1
    }
  ]
};



// WEBPACK FOOTER //
// src/pages/basepdc/Menu.basepdc.js